// src/pdf/MAPReportViewer.tsx
import { PDFViewer, pdf } from "@react-pdf/renderer";
import MAPReportPDF from "./MAPReportPDF";
import { Button } from "src/components/generic";
import { FunctionComponent, useEffect, useState } from "react";
import { dynamo } from "src/utils";
// import { ConfirmAccountForm } from "../forms";
import { v4 as uuidv4 } from "uuid";
import { Client } from "src/utils/types/UserTypes";

interface IMAPReportViewerProps {
  client: Client;
  reportASummary: any;
  reportBSummary: any;
  reportCSummary: any;
  pastDue: number;
  riskReport: any;
  creditReportType: string;
  scoreCards: Record<any, any>;
  saveOnLoad?: boolean;
}

const MAPReportViewer: FunctionComponent<IMAPReportViewerProps> = ({
  client,
  reportASummary,
  reportBSummary,
  reportCSummary,
  pastDue,
  riskReport,
  creditReportType,
  scoreCards,
  saveOnLoad,
}) => {
  const [loading, setLoading] = useState<boolean>(true);

  const handleDownload = async () => {
    const blob = await pdf(
      <MAPReportPDF
        client={client}
        reportASummary={reportASummary}
        reportBSummary={reportBSummary}
        reportCSummary={reportCSummary}
        pastDue={pastDue}
        riskReport={riskReport}
        creditReportType={creditReportType}
      />
    ).toBlob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${client?.userInfo?.name || "MAP_Report"}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const saveReport = async () => {
    console.log("Save Start", scoreCards);
    try {
      const map = {
        id: uuidv4(),
        date: new Date().toLocaleDateString(),
        client,
        reportASummary,
        reportBSummary,
        reportCSummary,
        pastDue,
        riskReport,
        creditReportType,
        scoreCards: scoreCards.map((card: Record<any, any>) => ({
          score: card.score,
          link: card.reportLink,
        })),
      };

      console.log({ map });

      const result = await dynamo.mutations.putMAP(map);

      if (Array.isArray(client.notes))
        client.notes.push({
          id: client.notes.length + 1,
          text: `MAP stored with ID: ${map.id}`,
          author: {
            name: "ClientVitals",
            id: "9438b498-00f1-70bd-860f-26da3b9cc48a",
          },
          date: new Date(),
        });
      else
        client.notes = [
          {
            id: 1,
            text: `MAP stored with ID: ${map.id}`,
            author: {
              name: "ClientVitals",
              id: "9438b498-00f1-70bd-860f-26da3b9cc48a",
            },
            date: new Date(),
          },
        ];

      await dynamo.mutations.putUser(client);

      console.log({ result });
    } catch (error) {
      console.log({ error });
      throw error;
    }
  };

  useEffect(() => {
    if (saveOnLoad && reportASummary && reportBSummary && reportCSummary)
      saveReport();
  }, [saveOnLoad, reportASummary, reportBSummary, reportCSummary]);

  return (
    <div className="flex flex-col items-center w-full">
      <div className="w-full h-[85vh] border rounded-lg shadow-xl overflow-hidden">
        <PDFViewer width="100%" height="100%" showToolbar>
          <MAPReportPDF
            client={client}
            reportASummary={reportASummary}
            reportBSummary={reportBSummary}
            reportCSummary={reportCSummary}
            pastDue={pastDue}
            riskReport={riskReport}
            creditReportType={creditReportType}
          />
        </PDFViewer>
      </div>

      <Button
        text="Download PDF"
        styles="mt-6 w-[220px] hover:scale-105 transition-all"
        onClick={handleDownload}
      />
    </div>
  );
};

export default MAPReportViewer;
